import { Component, OnInit } from '@angular/core';
import { SkeletonSizeBase } from '../../../common/Models/SkeletonSizesBase';

@Component({
  selector: 'skc-card-random-info',
  templateUrl: './card-random-info.component.html',
  styleUrls: ['./card-random-info.component.less']
})
export class CardRandomInfoComponent extends SkeletonSizeBase implements OnInit {
  lines = [
    { row: [100] },
    { row: [25, 75] },
    { row: [40, 60] },
    { row: [15, 85] },
    { row: [10, 25, 65] },
    { row: [30, 25, 35] }
  ];
  constructor() {
    super();
  }

  ngOnInit() {}
}
